module.exports = __webpack_public_path__ + "img/syukyaku-de-001sp.84b10202.jpg";